import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAirplay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"airplay"} maskId="square-filled-radius-0-stroke-1-IconAirplay"><path d="M2 3H22V18H17V17H21V4H3V17H7V18H2V3Z" fill="currentColor"/><path d="M16.9813 21.0005L11.9995 14.1504L7.01758 21.0005H16.9813Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAirplay;
